import React from 'react';
import { SelectionCardStyles as styles } from './LandingSubComponentStyles';

const SelectionCard = props => {
  var getStyle = key => {
    if (key in styles) return styles[key][props.viewMode];
  };
  return (
    <div
      style={{
        ...styles['selection_card_parent'][props.viewMode],
        width: props.width ? props.width : 0,
        height: props.height ? props.height : 0,
        backgroundColor: props.selected ? '#d6f2e0' : '#f3f5f7'
      }}
      onClick={props.onClick}
      className={'hover'}
    >
      {props.selected && (
        <img src={props.tick} style={getStyle('tick_style')} />
      )}

      <div style={getStyle('central_div_selection_card')}>
        <img src={props.type_icon} style={getStyle(props.type_style_tag)} />

        <div style={getStyle('type_text_selection_card')}>
          {props.type_text}
        </div>
      </div>
    </div>
  );
};

export default SelectionCard;
